<template>
  <section>
    <div class="columns" v-for="(provider, index) in data" :key="index">
      <div class="column">
        <b-field class="field" label="Live" horizontal>
          <b-input v-model="provider.live.source" />
        </b-field>
        <b-field class="field" label="Prelive" horizontal>
          <b-input v-model="provider.prelive.source" />
        </b-field>
      </div>
      <div class="column">
        <b-field class="field" label="Url" horizontal>
          <b-input v-model="provider.live.url" />
        </b-field>
        <b-field class="field" label="Url" horizontal>
          <b-input v-model="provider.prelive.url" />
        </b-field>
      </div>
      <div class="column">
        <b-field class="field" label="Name" horizontal>
          <b-input v-model="provider.live.name" />
        </b-field>
        <b-field class="field" label="Name" horizontal>
          <b-input v-model="provider.prelive.name" />
        </b-field>
      </div>
      <div class="column">
        <b-field class="field" label="Types" horizontal>
          <section class="checkbox-list">
            <b-checkbox
              v-for="value in types"
              v-model="provider.live.types"
              :native-value="value"
              :key="value">
              {{ value }}
            </b-checkbox>
          </section>
        </b-field>
        <b-field class="field" label="Types" horizontal>
          <section class="checkbox-list">
            <b-checkbox
              v-for="value in types"
              v-model="provider.prelive.types"
              :native-value="value"
              :key="value">
              {{ value }}
            </b-checkbox>
          </section>
        </b-field>
      </div>
      <div class="column is-narrow">
        <button class="button is-primary" type="button" @click="removeSource(index)">
          <b-icon icon="minus" />
        </button>
      </div>
    </div>
    <b-field horizontal class="field">
      <button class="button is-primary" type="button" @click="addSource">
        Add source
      </button>
    </b-field>
  </section>
</template>

<script>
export default {
  name: 'sportsbook-source',
  props: ['value'],
  data() {
    return {
      types: ['betradar'],
    }
  },
  computed: {
    data() {
      return this.value || []
    },
  },
  methods: {
    addSource() {
      const newItem = {
        live: { source: '', url: '', name: '', types: [] },
        prelive: { source: '', url: '', name: '', types: [] },
      }

      if (!Array.isArray(this.value)) {
        this.$emit('input', [newItem])
      } else {
        this.value.push(newItem)
      }
    },
    removeSource(index) {
      this.value.splice(index, 1)
    },
  },
}
</script>

<style scoped>
.checkbox-list {
  padding-top: 0.4em;
}
</style>


// WEBPACK FOOTER //
// src/components/Projects/Form/Custom/SportsbookSource.vue